/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Importing_VideoInputs */

const en_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing video file...`)
};

const fr_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du fichier vidéo...`)
};

const de_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videodatei wird importiert...`)
};

const it_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del file video...`)
};

const ru_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт видеофайла...`)
};

const es_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando archivo de vídeo...`)
};

const zh_cn2_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入视频文件...`)
};

const ja_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオファイルをインポートしています...`)
};

const hi_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो फ़ाइल आयात की जा रही है...`)
};

const pt_pt2_ateliere_connect_status_importing_video = /** @type {(inputs: Ateliere_Connect_Status_Importing_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando arquivo de vídeo...`)
};

/**
* | output |
* | --- |
* | "Importing video file..." |
*
* @param {Ateliere_Connect_Status_Importing_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_importing_video = /** @type {((inputs?: Ateliere_Connect_Status_Importing_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Importing_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_importing_video(inputs)
	if (locale === "de") return de_ateliere_connect_status_importing_video(inputs)
	if (locale === "it") return it_ateliere_connect_status_importing_video(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_importing_video(inputs)
	if (locale === "es") return es_ateliere_connect_status_importing_video(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_importing_video(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_importing_video(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_importing_video(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_importing_video(inputs)
	return en_ateliere_connect_status_importing_video(inputs)
});